import { render, staticRenderFns } from "./OverviewInstagram.vue?vue&type=template&id=1127a30a&scoped=true&"
import script from "./OverviewInstagram.vue?vue&type=script&lang=js&"
export * from "./OverviewInstagram.vue?vue&type=script&lang=js&"
import style0 from "./OverviewInstagram.vue?vue&type=style&index=0&id=1127a30a&scoped=true&lang=css&"
import style1 from "./OverviewInstagram.vue?vue&type=style&index=1&lang=css&"
import style2 from "./OverviewInstagram.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127a30a",
  null
  
)

export default component.exports